// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__OeQ4g","infoLink":"tweet-info_infoLink___soR1","infoIcon":"tweet-info_infoIcon__zYCOU"};